import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Job } from '../../../core/models/hangfireJobs/job.model';
import { RecurringJobService } from '../../../core/services/hangfire/recurringJobService.service';
import { ISelector } from '../interfaz/ISelector';

@Component({
  selector: 'app-job-selector',
  templateUrl: './job-selector.component.html',
  styleUrls: ['./job-selector.component.scss']
})
export class JobSelectorComponent implements OnInit, ISelector<Job> {

  constructor(protected recurringJobService: RecurringJobService) { }

  entities: Job[];

  @Output() selectedValueChange = new EventEmitter<Job>();

  private _recurringJobId: string;
  @Input() set recurringJobId(value: string) {
    this._recurringJobId = value;
    if (value !== '') {
      this.getEntities();
    }
  }
  get recurringJobId(): string {
    return this._recurringJobId;
  }

  @Input() value: number | string;
  @Input() placeHolder: string = '';
  @Input() dataSize: number = 7;
  @Input() required: boolean;

  getEntities() {
    if (this.recurringJobId) {
      this.recurringJobService.getJobs(this.recurringJobId).subscribe((response: Job[]) => {
        if (response) {
          this.entities = response;
        }
      }, error => console.error(error));
    }
  }

  ngOnInit() {
    this.getEntities();
  }

  onSelectedValueChange(event) {
    this.value = event;
    const entity = this.entities.find(x=> x.JobId == this.value);
    this.selectedValueChange.emit(entity);
  }

  getDescription(entity: Job): string {
    return `${entity.JobId} - ${entity.State} - ${entity.StartedAt}`;
  }

}
